export const zhCNAgentGuiSessionActions = {
  moreSessionActions: "更多会话操作",
  copiedToClipboard: "已复制",
  copyFailed: "复制失败",
  copyAsMarkdown: "复制为 Markdown",
  copyAsReference: "复制为引用",
  markSessionUnread: "标记为未读",
  retryConversations: "重试",
  conversationCopyImage: "图片",
  conversationCopyMentionPrefix: "@",
  conversationCopyFile: "文件",
  conversationCopyPreviousMessages: "{{count}} 条先前消息",
  conversationCopyImagesOmitted:
    "{{count}} 张图片过大未嵌入副本，可在对话中右键单张图片单独复制",
  conversationCopyInProgress: "正在复制会话…",
  sessionActionUnavailable: "当前无法执行会话操作"
};
